import React from "react";
import { AvatarSize, avatarSizes } from "./sizes";

interface PaziaAvatarPlaceholderProps {
  firstName: string;
  surname: string;
  size?: AvatarSize;
}

const textSizes: { [key in AvatarSize]: string } = {
  small: "text-xs font-semibold",
  medium: "text-3xl",
  smallMedium: "text-2xl",
  full: "text-4xl font-bold",
};
export const PaziaAvatarPlaceholder = ({ firstName, surname, size = "small" }: PaziaAvatarPlaceholderProps) => {
  const sizeClass = avatarSizes[size];
  const textClass = textSizes[size];

  const getInitials = () => {
    let initials = "";
    if (firstName) initials += firstName[0].toUpperCase();
    if (surname) initials += surname[0].toUpperCase();
    return initials;
  };

  return (
    <div
      className={`${sizeClass} ${textClass} flex items-center justify-center rounded-full bg-slate-100 uppercase text-slate-500 dark:bg-slate-700 dark:text-slate-400`}
    >
      {getInitials()}
    </div>
  );
};
